import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";
import { AbstractDocumentModel } from "./abstract-document-model";

export enum OpenDocumentPopupReason {
    view = "View",
    add = "Add",
    edit = "Edit",
}

export interface EditDocumentPopup {
    documents: AbstractDocumentModel[];
    documentTypes: SelectOptionModel[];
    canAddDocument: boolean;
    canEditDocument: boolean;
    openReason: OpenDocumentPopupReason;
    showDelete?: boolean;
}
